
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 5C11.714 5 5 11.714 5 20s6.714 15 15 15 15-6.714 15-15c0-.605-.044-1.201-.117-1.792a3.095 3.095 0 01-1.758.542A3.122 3.122 0 0130.2 16.7c-.781.497-1.704.8-2.7.8-2.764 0-5-2.236-5-5 0-.918.264-1.768.698-2.51a.376.376 0 01-.073.01A3.122 3.122 0 0120 6.875c0-.698.234-1.333.62-1.85C20.415 5.014 20.21 5 20 5zm9.375 0a1.875 1.875 0 100 3.75 1.875 1.875 0 000-3.75zM17.564 7.734a5.663 5.663 0 002.495 3.858c-.04.298-.059.605-.059.908 0 4.136 3.364 7.5 7.5 7.5.62 0 1.24-.078 1.836-.234a5.645 5.645 0 003.105 1.445C31.831 27.539 26.484 32.5 20 32.5c-6.895 0-12.5-5.605-12.5-12.5 0-6.06 4.336-11.128 10.064-12.266zM27.5 11.25c-.689 0-1.25.562-1.25 1.25s.561 1.25 1.25 1.25 1.25-.562 1.25-1.25-.561-1.25-1.25-1.25zm-10 1.25c-.689 0-1.25.562-1.25 1.25S16.811 15 17.5 15s1.25-.562 1.25-1.25-.561-1.25-1.25-1.25zm16.25 0c-.688 0-1.25.562-1.25 1.25S33.062 15 33.75 15 35 14.438 35 13.75s-.562-1.25-1.25-1.25zm-20 3.75a2.499 2.499 0 00-2.5 2.5c0 1.382 1.118 2.5 2.5 2.5s2.5-1.118 2.5-2.5-1.118-2.5-2.5-2.5zm6.25 2.5c-.689 0-1.25.561-1.25 1.25s.561 1.25 1.25 1.25 1.25-.561 1.25-1.25-.561-1.25-1.25-1.25zm-4.375 5a1.875 1.875 0 100 3.75 1.875 1.875 0 000-3.75zm8.75 1.25a1.875 1.875 0 100 3.75 1.875 1.875 0 000-3.75z"}})])
          )
        }
      }
    